// extracted by mini-css-extract-plugin
export const content = "email-verify-module--content--Qz7Y1";
export const btnPost = "email-verify-module--btnPost--9Zc8+";